const policyMainWrap = () => import("@/views/main_wrap.vue");

const createPolicyViewRoute = ({ path, name, component, aliases = [] }) => ({
    path,
    name,
    alias: aliases,
    component: policyMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const policyRoutes = [
    createPolicyViewRoute({
        path: "/policy/privacy-policy",
        name: "Gsrcm01",
        aliases: ["/gsrcm01", "/policy/gsrcm01"],
        component: () => import("@/views/policy/01/gsrcm01.vue")
    }),
    {
        path:  "/gsretail/ko/footer/privacy",
        redirect:"/policy/privacy-policy"
    },
    createPolicyViewRoute({
        path: "/policy/gs-shop-viewer",
        name: "Gsrcm0401",
        aliases: ["/gsrcm0401", "/policy/gsrcm0401"],
        component: () => import("@/views/policy/04/gsrcm0401.vue")
    })
];
